import React, { useState, useEffect } from "react";
import { 
  DateSelect,
  DocumentTypeSelect,
  CurrencySelect,
  CreateTable,
  Loading,
  FormatValueToDecimal,
  PostingKeySelect,
  FailMessage,
  DebitCreditSelect,
  ChartOfAccountsSelect,
  BusinessAreaSelect,
  ConfirmationModal,
  VendorSelect, CustomerSelect,
} from "../../common/APICommon";
import { v4 as uuidv4 } from "uuid";
import { motion, AnimatePresence } from "framer-motion";
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

export const JournalHeader = ({
  isEditable,
  type,
  journalLines, setJournalLines,
  documentNumber, setDocumentNumber,
  vendor, setVendor,
  customer, setCustomer,
  documentType, setDocumentType,
  documentDate, setDocumentDate,
  postingDate, setPostingDate,
  fiscalYear, setFiscalYear,
  fiscalPeriod, setFiscalPeriod,
  currency, setCurrency,
  referenceNumber, setReferenceNumber,
  documentHeaderText, setDocumentHeaderText,
  documentData,
}) => {
  const [loading, setLoading] = useState(false);
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [showJournalLines, setShowJournalLines] = useState(true);
  const [totalDebitAmount, setTotalDebitAmount] = useState(0);
  const [totalCreditAmount, setTotalCreditAmount] = useState(0);

  
//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion
  
  
  
  
  
  
  
//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion
  
  









//#region Journal Line
  const [selectedJournalLine, setSelectedJournalLine] = useState(null);
  const [currentPageJournalLine, setCurrentPageJournalLine] = useState(1);

  const headersJournalLine = [
    // 'POSTING KEY', 
    'DEBIT / CREDIT', 
    'ACCOUNT NAME', 
    'AMOUNT', 
    'ITEM TEXT', 
    'BUSINESS AREA', 
    'ACTIONS'
  ]
  const accessorsJournalLine = [
    // 'postingKey', 
    'postingKeyDebitCredit', 
    'glAccountName', 
    'amount', 
    'itemText', 
    'businessAreaDescription', 
    'actions'
  ]

  const [showAddJournalLineForm, setShowAddJournalLineForm] = useState(false);
  const openAddJournalLineForm = () => {
    setShowAddJournalLineForm(true);
  }
  const closeAddJournalLineForm = () => {
    setShowAddJournalLineForm(false);
    setSelectedJournalLine(null)
  }

  const [showUpdateJournalLineForm, setShowUpdateJournalLineForm] = useState(false);
  const openUpdateJournalLineForm = () => {
    setShowUpdateJournalLineForm(true);
  }
  const closeUpdateJournalLineForm = () => {
    setShowUpdateJournalLineForm(false);
    setSelectedJournalLine(null)
  }

  const editHandleJournalLineClick = async(_data) => {
    setLoading(true)
    setSelectedJournalLine(_data)

    setLoading(false)
    openUpdateJournalLineForm();
  }

  const [showViewJournalLineForm, setShowViewJournalLineForm] = useState(false);
  const openViewJournalLineForm = () => {
    setShowViewJournalLineForm(true);
  }
  const closeViewJournalLineForm = () => {
    setShowViewJournalLineForm(false);
    setSelectedJournalLine(null)
  }

  const viewHandleJournalLineClick = (_data) => {
    setSelectedJournalLine(_data)
    openViewJournalLineForm();
  }

  const [showDeleteJournalLineForm, setShowDeleteJournalLineForm] = useState(false);
  const openDeleteJournalLineForm = () => {
    setShowDeleteJournalLineForm(true);
  }
  const closeDeleteJournalLineForm = () => {
    setShowDeleteJournalLineForm(false);
    setSelectedJournalLine(null)
  }

  const deleteHandleJournalLineClick = (_data) => {
    setSelectedJournalLine(_data)
    openDeleteJournalLineForm();
  }

  const handleDeleteJournalLine = () => {
    setJournalLines(prev =>
      prev.filter(item =>
        (item.id ?? item.tempId) !==
        (selectedJournalLine.id ?? selectedJournalLine.tempId)
      )
    );
  };

  const actionsJournalLine = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleJournalLineClick,
      visible: isEditable === false,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleJournalLineClick,
      visible: isEditable === true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleJournalLineClick,
      visible: isEditable === true,
    },
  ];

  useEffect(() => {
    const _amount = journalLines.filter(i => i.postingKeyDebitCredit === "Debit")?.reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    setTotalDebitAmount(_amount)
  }, [journalLines, setTotalDebitAmount])
  useEffect(() => {
    const _amount = journalLines.filter(i => i.postingKeyDebitCredit === "Credit")?.reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    setTotalCreditAmount(_amount)
  }, [journalLines, setTotalCreditAmount])
//#endregion 






  return (
    <>
      {/* --- NEW SECTION: Source Document Reference --- */}
      {/* This part gives the user the info they need to type in the Journal Lines */}
      {documentData && 
        <div className="mb-8 p-4 bg-theme-color2/20 border border-blue-200 rounded-lg">
          <h3 className="text-sm font-bold text-theme-color uppercase tracking-wider mb-3">
            Reference Info (Source: {documentData?.paymentNumber})
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {/* <div>
              <p className="text-[10px] uppercase text-theme-color font-semibold">Payment Date</p>
              <p className="text-sm font-medium">{new Date(documentData?.paymentDate).toLocaleDateString()}</p>
            </div> */}
            <div>
              <p className="text-[10px] uppercase text-theme-color font-semibold">Reference #</p>
              <p className="text-sm font-medium">{documentData?.documentNumber}</p>
              <p className="text-xs font-medium">{new Date(documentData?.documentDate).toLocaleDateString()}</p>
            </div>
            <div>
              <p className="text-[10px] uppercase text-theme-color font-semibold">Vendor / Customer</p>
              <p className="text-sm font-medium">{documentData?.customerName1 ?? documentData?.vendorName1}</p>
            </div>
            <div>
              <p className="text-[10px] uppercase text-theme-color font-semibold">Reference</p>
              <p className="text-sm font-medium">{documentData?.referenceNumber}</p>
            </div>
            <div>
              <p className="text-[10px] uppercase text-theme-color font-semibold">Total Amount</p>
              <p className="text-sm font-bold text-theme-color">
                {getCurrency?.symbol} {FormatValueToDecimal(documentData?.amount || 0)}
              </p>
            </div>
          </div>
        </div>
      }

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Related Parties */}
        <>
          <div className="space-y-4 md:col-span-2 mt-2">
            <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Related Parties</h3>
          </div>

          {type === "AP" &&
            <>
              {vendor &&
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Vendor
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Vendor"
                      className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                      readOnly
                    />
                  </div>
                </div>
              }
              {customer &&
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Customer
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Customer"
                      className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                      readOnly
                    />
                  </div>
                </div>
              }
            </>
          }

          {type === "AR" &&
            <>
              {vendor &&
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Vendor
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Vendor"
                      className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                      readOnly
                    />
                  </div>
                </div>
              }
              {customer &&
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Customer
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Customer"
                      className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                      readOnly
                    />
                  </div>
                </div>
              }
            </>
          }

          {type === "GJ" &&
            <>
              <div>
                <label className="block text-sm font-semibold mb-1 text-gray-700">
                  Vendor 
                </label>
                <div className="flex flex-row items-center">
                  <input
                    type="text"
                    placeholder="Select Vendor"
                    className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                    readOnly
                  />
                  {!vendor ?
                    <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                      <PersonSearchIcon className="text-white"/>
                    </button> 
                    :
                    <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setVendor(null)}>
                      <RemoveCircleIcon className="text-white"/>
                    </button>
                  }
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold mb-1 text-gray-700">
                  Customer
                </label>
                <div className="flex flex-row items-center">
                  <input
                    type="text"
                    placeholder="Select Customer"
                    className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                    readOnly
                  />
                  {!customer ?
                    <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                      <PersonSearchIcon className="text-white"/>
                    </button> 
                    :
                    <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setCustomer(null)}>
                      <RemoveCircleIcon className="text-white"/>
                    </button>
                  }
                </div>
              </div>
            </>
          }
          <div>
        </div>
        </>
      </div>

      {/* Document Details */}
      <div>
        <div className="space-y-4 md:col-span-2 mt-10">
          <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Document Details</h3>
        </div>

        <div className="mt-5">
          <label className="block text-sm font-semibold mb-1 text-gray-700">
            Document Header Text <span className="text-red-500">*</span>
          </label>
          <input
            placeholder="Input document header text"
            className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
            value={documentHeaderText}
            onChange={(e) => setDocumentHeaderText(e.target.value)}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-5">
          <div>
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Document Type <span className="text-red-500">*</span>
            </label>
            <DocumentTypeSelect data={documentType} setData={setDocumentType} isEditable={false}/>
          </div>

          <div>
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Reference #
            </label>
            <input
              placeholder="0000-0000"
              className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
              value={referenceNumber}
              onChange={(e) => setReferenceNumber(e.target.value)}
              // readOnly
            />
          </div>

          <div>
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Document Date
            </label>
            <DateSelect data={documentDate} setData={setDocumentDate} isEditable={isEditable}/>
          </div>

          <div>
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Posting Date <span className="text-red-500">*</span>
            </label>
            <DateSelect data={postingDate} setData={setPostingDate} isEditable={isEditable}/>
          </div>

          <div>
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Fiscal Year
            </label>
            <input
              placeholder="yyyy"
              className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
              value={fiscalYear}
              onChange={(e) => setFiscalYear(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Fiscal Period
            </label>
            <input
              placeholder="----"
              className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
              value={fiscalPeriod}
              onChange={(e) => setFiscalPeriod(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Currency <span className="text-red-500">*</span>
            </label>
            <CurrencySelect data={currency} setData={setCurrency} isEditable={isEditable}/>
          </div>
        </div>
      </div>

      {/* Journal Lines */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* --- Section 2: Journal Lines (Expandable) --- */}
        <div className="md:col-span-2 mt-10">
          {/* Toggle Header Button */}
          <button
            type="button"
            onClick={() => setShowJournalLines(!showJournalLines)}
            className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
          >
            <div className="flex items-center gap-2">
              <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showJournalLines ? 'text-theme-color' : 'text-gray-400'}`}>
                Line Items
              </h3>
              {/* Badge showing count */}
              {journalLines?.length > 0 && (
                <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                  {journalLines.length}
                </span>
              )}
            </div>
            
            <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showJournalLines ? "rotate-180" : ""}`}>
              <ExpandMoreIcon /> 
            </div>
          </button>

          {/* Expandable Content Area */}
          <AnimatePresence>
            {showJournalLines && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="overflow-hidden"
              >
                <div className="py-5 space-y-5">
                  {/* Add button */}
                  <div className="flex gap-3 w-full justify-start">
                    {isEditable &&
                      <button 
                        type="button"
                        onClick={openAddJournalLineForm} 
                        className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                      >
                        <AddCircleOutlineIcon fontSize="small" /> 
                        New Line
                      </button>
                    }
                  </div>

                  {/* List of Journal Line */}
                  <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                    <CreateTable
                      tableName={"Journal Line"}
                      headers={headersJournalLine}
                      accessors={accessorsJournalLine}
                      data={journalLines}
                      actions={actionsJournalLine}
                      currentPage={currentPageJournalLine}
                      setCurrentPage={setCurrentPageJournalLine}
                      itemsPerPage={10}
                      totalItems={journalLines?.length}
                    />
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Summary when collapsed (Optional) */}
          {!showJournalLines && journalLines?.length > 0 && (
            <motion.p 
              initial={{ opacity: 0 }} 
              animate={{ opacity: 1 }} 
              className="text-[11px] text-gray-400 mt-2 italic"
            >
              Click to view {journalLines.length} line items...
            </motion.p>
          )}
        </div>

        {/* --- Section 3: Final Summary --- */}
        <div className="md:col-span-2">
          <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start gap-6">
            
            {/* Left Side: Details Breakdown */}
            <div className="flex gap-4 w-full lg:w-auto">
              <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                <AccountBalanceWalletIcon className="text-theme-color" />
              </div>
              
              <div className="flex-1 space-y-3">
                <div>
                  <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                    Journal Lines Summary
                  </p>
                  <p className="text-xs text-gray-500">Breakdown of all line items</p>
                </div>
              </div>
            </div>

            {/* Right Side: Final Total & Status */}
            <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
              <p className="text-[10px] font-bold uppercase tracking-widest text-green-600 mb-1">
                Total Debit Amount
              </p>
              <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                <span className="text-4xl font-black text-green-700 tracking-tight">
                  {`+ ${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalDebitAmount)}`}
                </span>
              </div>
              <p className="text-[10px] font-bold uppercase tracking-widest text-red-400 mb-1">
                Total Credit Amount
              </p>
              <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                <span className="text-4xl font-black text-red-500 tracking-tight">
                  {`- ${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalCreditAmount)}`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={vendor} setData={setVendor}
      />
      
      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={customer} setData={setCustomer}
      />

      <JournalLines
        visible={showAddJournalLineForm} 
        onClose={closeAddJournalLineForm} 
        // onSave={}
        modalName={"Add Journal Line"}
        data={selectedJournalLine}
        journalLines={journalLines} setJournalLines={setJournalLines}
        isEditable={isEditable}
        documentData={documentData}
        type={type}
      />

      <JournalLines
        visible={showUpdateJournalLineForm} 
        onClose={closeUpdateJournalLineForm} 
        // onSave={}
        modalName={"Update Journal Line"}
        data={selectedJournalLine}
        journalLines={journalLines} setJournalLines={setJournalLines}
        isEditable={isEditable}
        documentData={documentData}
        type={type}
      />

      <JournalLines
        visible={showViewJournalLineForm} 
        onClose={closeViewJournalLineForm} 
        // onSave={}
        modalName={"View Journal Line"}
        data={selectedJournalLine}
        journalLines={journalLines} setJournalLines={setJournalLines}
        isEditable={false}
        documentData={documentData}
        type={type}
      />

      <ConfirmationModal 
        visible={showDeleteJournalLineForm} 
        onClose={closeDeleteJournalLineForm} 
        onSave={handleDeleteJournalLine} 
        modalName={"Delete"} 
        message={`Do you want to remove this item [ ${selectedJournalLine?.postingKeyDescription ?? ""} ]?.`}
      />

      { loading && <Loading />}
    </>
  )
}

export const JournalLines = ({
  visible, onClose, onSave, modalName,
  data,
  journalLines, setJournalLines,
  isEditable,
  documentData,
  type
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const [failMessage, setFailMessage] = useState("");
  const [postingKey, setPostingKey] = useState(null);
  const [glAccount, setGLAccount] = useState(null);
  const [amount, setAmount] = useState(0);
  const [itemText, setItemText] = useState("");
  const [businessArea, setBusinessArea] = useState(null);

  const [showGLAccountForm, setShowGLAccountForm] = useState(false);
  const openGLAccountSelectForm = () => {
    setShowGLAccountForm(true);
  }
  const closeGLAccountSelectForm = () => {
    setShowGLAccountForm(false);
  }

  const [showPostingKeyForm, setShowPostingKeyForm] = useState(false);
  const openPostingKeySelectForm = () => {
    setShowPostingKeyForm(true);
  }
  const closePostingKeySelectForm = () => {
    setShowPostingKeyForm(false);
  }

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!postingKey
      || !glAccount
    ) {
      setFailMessage("Please fill up all required fields.");
      return;
    }

    if(modalName === "Add Journal Line"){
      const newData = {
        id: null,
        tempId: uuidv4(),
        postingKey: postingKey,
        postingKeyId: postingKey?.id,
        postingKeyCode: postingKey?.postingKeyCode,
        postingKeyDebitCredit: postingKey?.debitCredit,
        postingKeyDescription: postingKey?.description,
        glAccount: glAccount,
        glAccountId: glAccount?.id,
        glAccountNumber: glAccount?.accountNumber,
        glAccountName: glAccount?.accountName,
        amount: parseFloat(amount),
        itemText: itemText,
        businessAreaId: businessArea?.id,
        businessAreaDescription: businessArea?.description,
        businessArea: businessArea,
      }

      setJournalLines((prev) => [...prev, newData])
    }

    if(modalName === "Update Journal Line"){
      const newData = {
        ...data,
        postingKey: postingKey,
        postingKeyId: postingKey?.id,
        postingKeyCode: postingKey?.postingKeyCode,
        postingKeyDebitCredit: postingKey?.debitCredit,
        postingKeyDescription: postingKey?.description,
        glAccount: glAccount,
        glAccountId: glAccount?.id,
        glAccountNumber: glAccount?.accountNumber,
        glAccountName: glAccount?.accountName,
        amount: parseFloat(amount),
        itemText: itemText,
        businessAreaId: businessArea?.id,
        businessAreaDescription: businessArea?.description,
        businessArea: businessArea,
      }

      setJournalLines(prev =>
        prev.map(item =>
          (item.id ?? item.tempId) === (data.id ?? data.tempId)
            ? newData
            : item
        )
      );
    }

    closeModal();
  };

  const resetLocalVariables = () => {
    setPostingKey(null)
    setGLAccount(null)
    setAmount(0)
    setItemText("")
    setBusinessArea(null)
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if(visible){
      setPostingKey(data?.postingKey ?? null)
      setGLAccount(data?.glAccount ?? null)
      setAmount(data?.amount ?? 0)
      setItemText(data?.itemText ?? "")
      setBusinessArea(data?.businessArea ?? null)
    }
  }, [visible, data])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the line details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              {/* --- NEW SECTION: Source Document Reference --- */}
              {/* This part gives the user the info they need to type in the Journal Lines */}
              {documentData && 
                <div className="mb-8 p-4 bg-theme-color2/20 border border-blue-200 rounded-lg">
                  <h3 className="text-sm font-bold text-theme-color uppercase tracking-wider mb-3">
                    Reference Info (Source: {documentData?.paymentNumber})
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {/* <div>
                      <p className="text-[10px] uppercase text-theme-color font-semibold">Payment Date</p>
                      <p className="text-sm font-medium">{new Date(documentData?.paymentDate).toLocaleDateString()}</p>
                    </div> */}
                    <div>
                      <p className="text-[10px] uppercase text-theme-color font-semibold">Reference #</p>
                      <p className="text-sm font-medium">{documentData?.documentNumber}</p>
                      <p className="text-xs font-medium">{new Date(documentData?.documentDate).toLocaleDateString()}</p>
                    </div>
                    <div>
                      <p className="text-[10px] uppercase text-theme-color font-semibold">Vendor / Customer</p>
                      <p className="text-sm font-medium">{documentData?.customerName1 ?? documentData?.vendorName1}</p>
                    </div>
                    <div>
                      <p className="text-[10px] uppercase text-theme-color font-semibold">Reference</p>
                      <p className="text-sm font-medium">{documentData?.referenceNumber}</p>
                    </div>
                    <div>
                      <p className="text-[10px] uppercase text-theme-color font-semibold">Total Amount</p>
                      <p className="text-sm font-bold text-theme-color">
                        {getCurrency?.symbol} {FormatValueToDecimal(documentData?.amount || 0)}
                      </p>
                    </div>
                  </div>
                </div>
              }
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Line Item Details</h3>
                  </div>

                  { isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Post Key <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${postingKey ? `${postingKey?.postingKeyCode} - ${postingKey?.description}` : ""}`}
                          readOnly
                        />
                        {!postingKey ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openPostingKeySelectForm}>
                            <ManageSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setPostingKey(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Post Key <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${postingKey ? `${postingKey?.postingKeyCode} - ${postingKey?.description}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  { isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Account Name <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${glAccount ? `${glAccount?.accountNumber} - ${glAccount?.accountName}` : ""}`}
                          readOnly
                        />
                        {!glAccount ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openGLAccountSelectForm}>
                            <ManageSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setGLAccount(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Account Name <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${glAccount ? `${glAccount?.accountNumber} - ${glAccount?.accountName}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Debit / Credit <span className="text-red-500">*</span>
                    </label>
                    <DebitCreditSelect data={postingKey?.debitCredit} isEditable={false}/>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Amount <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="number"
                        className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        readOnly={!isEditable}
                      />
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(amount || 0)}
                      </span>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Item Text
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        placeholder="ITEM-0000"
                        className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={itemText}
                        onChange={(e) => setItemText(e.target.value)}
                        readOnly={!isEditable}
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Business Area
                    </label>
                    <BusinessAreaSelect data={businessArea} setData={setBusinessArea} isEditable={isEditable}/>
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      <PostingKeySelect 
        visible={showPostingKeyForm} 
        onClose={closePostingKeySelectForm}
        modalName={"Select Posting Key"}
        data={postingKey} setData={setPostingKey}
        type={type}
      />
      
      <ChartOfAccountsSelect 
        visible={showGLAccountForm} 
        onClose={closeGLAccountSelectForm}
        modalName={"Select Account"}
        data={glAccount} setData={setGLAccount}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};